import type { hotOffersTypes } from '@/entities/hot-offers';

import { emojiMap } from '../config';

export const getMappedCityNameWithEmoji = (city: hotOffersTypes.MappedCity) => {
  const emoji = emojiMap[city.code] || '✈️';
  return `${city.name} ${emoji}`;
};
